import React from "react";
import LongLogo from '../../../../Resources/Logo/logo2.png';

function STCLogoLong(props){
    return(
        <img
            alt={'STCLongLogo'}
            style={props.style}
            className={props.className}
            src={LongLogo}
        />
    )
}
export default STCLogoLong;